<template>
  <transition name="modal">
    <div class="modal-mask ">
      <div class="modal-wrapper">
        <div class="modal-container block">

          <div class="modal-header ">
            <slot name="header">
              {{ title }}
            </slot>
          </div>
          <hr/>

          <div class="modal-body">
            <slot name="body">
              {{ msg }}
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button v-if="showOK" class="modal-default-button smallButton green" @click="$emit('closeOK')">
                {{ btnOK }}
              </button>
              <button v-if="showCancel" class="modal-default-button smallButton red" @click="$emit('closeCancel')">
                {{btnCancel}}
              </button>
              <div class="clear"></div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalDialog",
  props:{
    title:{
      type: String,
      default: "Info"
    },
    msg:{
      type: String,
      default: "Zprava"
    },
    btnOK:{
      type: String,
      default: "OK"
    },
    btnCancel:{
      type:String,
      default: "Zrušit"
    },
    showOK:{
      type:Boolean,
      default: true
    },
    showCancel:{
      type:Boolean,
      default: false
    }
  }


}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 450px;
  margin: 0 auto;
  padding: 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 9px 9px 15px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  text-align: left;
  font-weight: bold;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  width: 100%;

}

.modal-default-button {
  float: right;
  margin-bottom: 3px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>